export default function initEventFilters() {
	const $form = document.querySelector("[data-event-filter-form]");
	const $eventListing = document.querySelector("[data-event-listing]");
	const $clearButton = document.querySelector("[data-clear-filters]");

	if (!$form || !$eventListing || !$clearButton) {
		return;
	}

	const $filters = $form.querySelectorAll("[data-event-filter]");

	// Check if any filter is active and show/hide clear button
	const updateClearButtonVisibility = () => {
		const hasActiveFilter = Array.from($filters).some(
			$filter => $filter.checked
		);
		$clearButton.classList.toggle("is-active", hasActiveFilter);
	};

	const handleFilterChange = async e => {
		$eventListing.classList.add("is-loading");

		try {
			const formData = new FormData($form);
			const searchParams = new URLSearchParams(formData);

			const response = await fetch(
				`${window.location.pathname}?${searchParams}`,
				{
					headers: {
						"X-Requested-With": "XMLHttpRequest"
					}
				}
			);

			if (!response.ok) {
				throw new Error("Network response was not ok");
			}

			const data = await response.json();

			$eventListing.innerHTML = data.html;
			$eventListing.classList.remove("is-loading");

			const newUrl = `${window.location.pathname}?${searchParams}`;
			window.history.pushState({}, "", newUrl);

			updateClearButtonVisibility();
		} catch (error) {
			console.error("Error filtering events:", error);
			$eventListing.classList.remove("is-loading");
			$form.submit();
		}
	};

	const handleClearFilters = async () => {
		$filters.forEach($filter => {
			$filter.checked = false;
		});

		await handleFilterChange();
	};

	$filters.forEach($filter => {
		$filter.addEventListener("change", handleFilterChange);
	});

	$clearButton.addEventListener("click", handleClearFilters);

	updateClearButtonVisibility();
}
